import { ButtonSizeOptions, ButtonTypes, Constants } from '@finxone-platform/shared/sys-config-types';
import { BackButtonWidgetBuilder, SpacerWidgetBuilder, TextWidgetBuilder } from '../../../../widgets';

const notificationDetailsTemplate = `
  <div class="w-100">
    <div class="is-space-between w-100 mb-3">
      <div class="labelText textOnSurfaceMuted">Full Name</div>
      <div class="body2 text-right textOnSurface text-capitalize">
       {{ profile.fullName }}
      </div>
    </div>
    <hr/ class="my-4">

    <div class="is-space-between w-100 mb-3">
      <div class="labelText textOnSurfaceMuted">Phone Number</div>
      <div class="body1 text-right textOnSurface">
       {{ profile.phoneNumber }}
      </div>
    </div>
    <div class="is-space-between w-100 mb-3">
      <div class="labelText textOnSurfaceMuted"> Email</div>
      <div class="body1 text-right textOnSurface">
       {{ profile.email }}
      </div>
    </div>

     <hr/ class="my-4">

    <div class="is-space-between w-100 mb-3">
      <div class="labelText textOnSurfaceMuted">City</div>
      <div class="body1 text-right textOnSurface text-capitalize">
     {{ profile.city }}
      </div>
    </div>

     <div class="is-space-between w-100 mb-3">
      <div class="labelText textOnSurfaceMuted">County</div>
      <div class="body1 text-right textOnSurface text-capitalize">
      {{ profile.county }}
      </div>
    </div>

     <div class="is-space-between w-100 mb-3">
      <div class="labelText textOnSurfaceMuted">Postal Code</div>
      <div class="body1 text-right textOnSurface text-capitalize">
      {{ profile.postalCode }}
      </div>
    </div>

  </div>
`;

export const notificationKycApplicationSuccessWidgets = [
  new TextWidgetBuilder()
    .configDisplayName('Text Widget: Application Successful')
    .setWidgetProperties({ textStyleClass: 'h6', textContent: 'Application Successful' })
    .cssConfig({
      color: 'var(--color-on-background)',
      textAlignment: 'center',
      textFont: 'var(--font-family)',
    })
    .build(),

  new TextWidgetBuilder()
    .configDisplayName('Text Widget: Information')
    .setWidgetProperties({
      textStyleClass: 'body1',
      textContent: `Your KYC application has been approved. You’re all set to use our services.`,
    })
    .cssConfig({
      color: 'var(--color-on-background-muted)',
      textAlignment: 'center',
      textFont: 'var(--font-family)',
    })
    .build(),

  new SpacerWidgetBuilder().setHeight({ height: 30, unit: 'px' }).build(),

  new TextWidgetBuilder()
    .configDisplayName('Text Widget: Notification Details')
    .setWidgetProperties({
      textStyleClass: 'body1',
      textContent: notificationDetailsTemplate,
    })
    .cssConfig({
      ...Constants.defaultBaseCssConfig,
      backGroundColor: 'var(--color-surface)',
      borderRadiusTopLeft: 8,
      borderRadiusBottomLeft: 8,
      borderRadiusTopRight: 8,
      borderRadiusBottomRight: 8,
      paddingTop: 24,
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 24,
    })
    .build(),

  new SpacerWidgetBuilder().setHeight({ height: 20, unit: 'vh' }).build(),

  new BackButtonWidgetBuilder()
    .icon('')
    .configDisplayName('Back Button')
    .text('Back')
    .setGlobalStylingClass(true, `${ButtonTypes.SECONDARY} ${ButtonSizeOptions.FULL_WIDTH}`)
    .build(),
];
